import { render, staticRenderFns } from "./NodePanel.vue?vue&type=template&id=1d295585&scoped=true&"
import script from "./NodePanel.vue?vue&type=script&lang=js&"
export * from "./NodePanel.vue?vue&type=script&lang=js&"
import style0 from "./NodePanel.vue?vue&type=style&index=0&id=1d295585&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d295585",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\Project\\嘀嗒嘀关务\\ddd_cms_web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1d295585')) {
      api.createRecord('1d295585', component.options)
    } else {
      api.reload('1d295585', component.options)
    }
    module.hot.accept("./NodePanel.vue?vue&type=template&id=1d295585&scoped=true&", function () {
      api.rerender('1d295585', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/other/workflow/components/lFComponents/NodePanel.vue"
export default component.exports